import { useAtticAssetUploads } from "../../hooks/useAtticAssetUploads";
import { type AtticAssetPut } from "../../upload";
import { AtticAssetUploadCard } from "./AtticAssetUploadCard";

export interface AtticAssetUploaderProps {
  directoryId: string;
  maxUploadBytes: number;
  writable: boolean;
  /** Refresh the directory's file list (throttled by the queue). */
  onUploaded: () => void;
  /** The bucket PUT; tests stand in for the network here. */
  put?: AtticAssetPut;
}

/**
 * The upload card with its queue. The queue's state lives here, not in the
 * directory view, so a progress tick re-renders this card alone and never
 * the file table beside it.
 */
export const AtticAssetUploader = ({
  directoryId,
  maxUploadBytes,
  writable,
  onUploaded,
  put,
}: AtticAssetUploaderProps) => {
  const uploads = useAtticAssetUploads({
    directoryId,
    maxUploadBytes,
    onUploaded,
    transport: put ? { put } : undefined,
  });

  return (
    <AtticAssetUploadCard
      maxUploadBytes={maxUploadBytes}
      writable={writable}
      items={uploads.items}
      inFlight={uploads.inFlight}
      onUpload={uploads.upload}
      onCancel={uploads.cancel}
      onClearFinished={uploads.clearFinished}
    />
  );
};

export default AtticAssetUploader;
